var React = require('react');

function PixelPerfect (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M1 41h10v10H1zm52 0h10v10H53zM27 13h10v10H27z","key":0}),React.createElement("circle",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","cx":"4","cy":"18","r":"3","key":1}),React.createElement("circle",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","cx":"60","cy":"18","r":"3","key":2}),React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M7 18h20C6 18 6 41 6 41m51-23H37c21 0 21 23 21 23","key":3})]);
}

PixelPerfect.defaultProps = {"version":"1.0","width":"64","height":"64"};

module.exports = PixelPerfect;

PixelPerfect.default = PixelPerfect;
